import styled from "styled-components";
import texture from './assets/texture.jpg'

type Props = {
    $width?: number
    $image?: boolean
}

export default styled.div<Props>`
    display: block;
    position: relative;
    z-index: 5;
    box-sizing: border-box;
    border: 0px solid rgba(30, 10, 60, 0.4);
   
    
    background-size: 200% 200%;

    ${({ $image }) => $image && `
        height: auto;
        padding: 2rem;

        & img {
            width: 100%;
            margin-bottom: 2rem;
            filter:  brightness(1.3) saturate(1.2);
        }
    `}
    width: ${props => (props.$width || 1) * 14}rem;
`